import { css } from '@eti/styles';
import { Inline, Radio, RadioGroup, Stack } from '@etg/wings';
import type { ReactElement } from 'react';
import React from 'react';
import Filter from '../Filter';

const labelStyles = css`
  font-size: 0.875rem;
`;

interface RadioFilterProps {
  className?: string;
  children: ReactElement;
  isInitiallyExpanded: boolean;
  isSelected: boolean;
  isToggleable: boolean;
  label: string;
  name: string;
  onFilter: (filterOptions: Record<string, string | null>) => void;
  onReset: (...args: any) => void;
  options: {
    id: string;
    label: string;
    value: string;
    dataTestId?: string;
  }[];
  selectedValue: string;
  shouldShowResetButton?: boolean;
}

const RadioFilter = ({
  className = '',
  children,
  isInitiallyExpanded,
  isSelected,
  isToggleable,
  label,
  name,
  onFilter,
  onReset,
  options,
  selectedValue,
  shouldShowResetButton = true,
}: RadioFilterProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    return onFilter({ [name]: value === '-1' ? null : value });
  };

  return (
    <Filter
      className={className}
      isInitiallyExpanded={isInitiallyExpanded}
      isSelected={isSelected}
      isToggleable={isToggleable}
      label={label}
      name={name}
      onReset={onReset}
      shouldShowResetButton={shouldShowResetButton}
    >
      <RadioGroup name={name} onChange={handleChange} selectedValue={selectedValue}>
        <Stack align="start" spacing={8}>
          {options.map((option) => (
            <Radio.Label
              className={labelStyles}
              data-testid={option.dataTestId?.replace(' ', '')}
              key={option.id}
            >
              <Inline alignY="center" spacing={8}>
                <Radio id={option.id?.replace(' ', '')} value={option.value} />
                {option.label}
              </Inline>
            </Radio.Label>
          ))}
        </Stack>
      </RadioGroup>
      {children}
    </Filter>
  );
};

export default RadioFilter;
